import React, { Component } from 'react';
import { News } from '../News.interface';
import { mockedNews } from '../mockedNews';
import SingleNewsPreview from '../SingleNewsPreview/SingleNewsPreview';
import { environments } from 'environments/environments';
import DTHead from 'assets/img/DT_head.png';
import './NewsList.css';

export default class NewsList extends Component {
  state = {
    news: [],
    loading: true,
    error: false,
    displayLoading: false
  }

  mockedNews: News[] = mockedNews;
  controller = new AbortController();
  mounted = false;
  noMore = false;

  componentDidMount() {
    this.getNews();
    this.showLoadingMessage();
    this.mounted = true;
  }

  componentWillUnmount() {
    this.controller.abort();
    this.mounted = false;
  }

  /** Displays loading message if news aren't loaded in short time */
  showLoadingMessage() {
    setTimeout(() => {
      if (this.state.loading && this.mounted) {
        this.setState({ displayLoading: true });
      }
    }, 300);
  }

  /** Loads news (both initial and more news) */
  getNews() {
    this.setState({ loading: true });
    const newsNum = this.state.news.length;
    const anticache = new Date().getTime();
    const params = `?count=5${newsNum ? '&from=' + newsNum : ''}&anticache=${anticache}`;
    fetch(environments.server + environments.backend + params, { signal: this.controller.signal })
      .then(async res => {
        const news: News[] = await res.json();
        // console.log(news);
        const currentNews = this.state.news;
        if (news && news.length) {
          this.setState({ news: [...currentNews, ...news], loading: false, displayLoading: false, error: false });
        } else {
          this.noMore = true;
          this.setState({ news: currentNews, loading: false, displayLoading: false, error: true });
        }
      }).catch(e => {
        if (this.mounted) {
          this.setState({ news: [], loading: false, displayLoading: false, error: true });
        }
      });
  }

  render() {
    const news = this.state.news as News[];
    const renderNews = news.map(n => <SingleNewsPreview key={n.id} news={n} />);
    const renderLoadingHead = this.state.loading
      ? <span className="loading loading-spinner"></span>
      : <img className="small-loading-head" src={DTHead} alt="+" />;
    const renderLoading = <div className="news-body not-done section">
      <p>{renderLoadingHead} Novinky se načítají, vyčkejte prosím... {renderLoadingHead}</p>
      <p>...nebo je zkuste načíst <span onClick={() => this.getNews()}>ZNOVU</span>, jestli to trvá moc dlouho.</p>
    </div>;
    const renderError = <div className="news-body not-done section">
      <p>Novinky se nepovedlo načíst.</p>
      <p>
        Zkuste to <span onClick={() => this.getNews()}>ZNOVU </span>
        nebo se podívejte na ostatní sekce.
      </p>
    </div>;

    return (
      <div className="section news-list">
        {this.state.news.length
          ? renderNews
          : this.state.error
            ? renderError
            : this.state.loading
              ? this.state.displayLoading
                ? renderLoading
                : null
              : renderError}
        <br />
        {this.state.news.length && !this.noMore
          ? <p className="fake-link" onClick={() => { if (!this.state.loading) { this.getNews() } }}>
            {renderLoadingHead} &nbsp; Načíst starší novinky
          </p>
          : null
        }
      </div>
    );
  }
}
